import api from '../utils/api';
import { qs } from '../utils/utils'

export const getOurCategories = async () => {
    try {
        const response = await api.get(`/ourCategories`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getOurCategoriesItemsByID = async (id, params) => {
    try {
        const response = await api.get(`/ourCategoriesItems/ourCategories/${id}?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getOurCategoriesItems = async (params) => {
    try {
        const response = await api.get(`/ourCategoriesItems?${qs(params)}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getItemsByID = async (id) => {
    try {
        const response = await api.get(`/ourCategoriesItems/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const getOurCategorybyId = async (id) => {
    try {
        const response = await api.get(`/ourCategories/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}


export const addOurCategory = async (formData) => {
    try {
        const response = await api.post(`/ourCategories/add`, formData);
        if (response?.status === 201) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const updateOurCategory = async (formData, id) => {
    try {
        const response = await api.put(`/ourCategories/${id}`, formData);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}

export const deleteOurCategory = async (id) => {
    try {
        const response = await api.delete(`/ourCategories/${id}`);
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message };
    }
}